import { useCallback, useEffect, useState } from 'react';

import { convertMemoryToGi } from '../../../utils/memory';
import { getComputeResourceLimit } from '../api';

interface UseComputeResourceLimitsOptions {
  namespace?: string;
  vmName?: string;
  defaultCpuMax?: number;
  defaultMemoryMax?: number;
  enabled?: boolean;
}

export function useComputeResourceLimits({
  namespace,
  vmName,
  defaultCpuMax = 128,
  defaultMemoryMax = 2048,
  enabled = true,
}: UseComputeResourceLimitsOptions) {
  const [cpuMax, setCpuMax] = useState(defaultCpuMax);
  const [memoryMax, setMemoryMax] = useState(defaultMemoryMax);

  const loadLimits = useCallback(async () => {
    if (!enabled || !namespace) return;
    try {
      const res = await getComputeResourceLimit(namespace, vmName || 'placeholder');
      const cpuArr: number[] = [];
      const memArr: number[] = [];
      Object.values(res || {}).forEach((item) => {
        if (item?.cpu) cpuArr.push(Math.floor(item.cpu));
        if (item?.memory) memArr.push(convertMemoryToGi(item.memory));
      });
      if (cpuArr.length) setCpuMax(Math.max(...cpuArr));
      if (memArr.length) setMemoryMax(Math.max(...memArr));
    } catch (error) {
      console.log(error);
    }
  }, [enabled, namespace, vmName]);

  useEffect(() => {
    void loadLimits();
  }, [loadLimits]);

  return { cpuMax, memoryMax };
}
